import type { AllFeatureIds } from 'generated/featureIds.generated'
import type { $Values } from 'utility-types'

export const CHECKED_FEATURES: Record<string, AllFeatureIds> = {
  create_custom_leave_types: 'create_custom_leave_types',
  ats_show_hiring_phases: 'ats_show_hiring_phases',
  esignature: 'esignature',
  show_integrations_on_apps_store: 'show_integrations_on_apps_store',
  create_custom_folders: 'custom_folders',
}

export type CheckedFeature = $Values<typeof CHECKED_FEATURES>

const TRACKING_PAGES = {
  appStore: 'AppStore',
  automation: 'Automation',
  adminClockIn: 'AdminClockIn',
  clockIn: 'ClockIn',
  competencies: 'Competencies',
  companyDocuments: 'CompanyDocuments',
  dashboard: 'Dashboard',
  documentsInBulk: 'DocumentsInBulk',
  employee: 'Employees',
  employeeDocuments: 'EmployeeDocuments',
  faceRecognition: 'FaceRecognition',
  allEmployeeDocuments: 'AllEmployeeDocuments',
  goals: 'Goals',
  jobs: 'Jobs',
  myDocuments: 'MyDocuments',
  omniButton: 'OmniButton',
  onboarding: 'Onboarding',
  plans: 'Plans',
  profile: 'Profile',
  reports: 'Reports',
  roundedToolbar: 'RoundedToolbar',
  reviews: 'Reviews',
  shiftManagement: 'ShiftManagement',
  sidebar: 'Sidebar',
  surveys: 'Surveys',
  tasks: 'Tasks',
  teams: 'Teams',
  timeOff: 'TimeOff',
  topBanner: 'TopBanner',
  trialDemo: 'Demo',
  welcome: 'Welcome',
}

const ALL_TRACKED_THINGS = { ...TRACKING_PAGES, ...CHECKED_FEATURES }

const TRACKING_ELEMENTS = {
  button: 'Button',
  card: 'Card',
  menuItem: 'Item',
  modal: 'Modal',
  pad: 'Pad',
  videoPlayer: 'VideoPlayer',
}

const TRACKING_ACTIONS = {
  click: 'click',
  open: 'open',
  close: 'close',
}
export type PageNameProps = $Values<typeof ALL_TRACKED_THINGS>

export type ElementNameProps = $Values<typeof TRACKING_ELEMENTS>

export type ActionNameProps = $Values<typeof TRACKING_ACTIONS>
